function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0.5) translate(-200%, -3em);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import { keyframes } from 'styled-components';
var Pan = keyframes(_templateObject());
export default Pan;